angular.module('routes.magic.MagicPayloadResolver', [
  'stack'
])

/**
 * The MagicPayloadResolver provides an initial payload of data
 * required by the entire app
 *
 * @class MagicPayloadResolver
 * @constructor
 * @module routes.magic.MagicPayloadResolver
 */
.factory('MagicPayloadResolver', [
  'GLOBAL',
  'ModelsService',
  function (GLOBAL, ModelsService) {
    'use strict';

    return function () {
      return ModelsService.initialize('cases', GLOBAL.apiPath + '/cases');
    };
  }
]);
